module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zh.1aa58613.jpg";